import { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';

import ShareLink from 'uI/ShareLink/ShareLink';

import { getShareLink } from 'store/product-actions';

import classes from './LeftSection.module.css';

const LeftSection = props => {
  const userInfo = useSelector(state => state.userInfo);
  const { idProduct } = useParams();
  const [openMessage, setOpenMessage] = useState(false);
  const [link, setLink] = useState('');

  const shareLinkHandler = () => {
    (async () => {
      setLink(await getShareLink(idProduct, 2));
      setOpenMessage(true);
    })();
  };

  const closeDialogHandler = () => {
    setOpenMessage(false);
  };

  return (
    <>
      <aside className={classes.leftContainer}>
        <div className={classes.section}>
          <figure className={classes.imgBook}>
            <img
              className={classes.img}
              src={props.data.imagenUrlKotobeeEmail}
              alt={props.data.productName}
            />
          </figure>
          <p className={classes.title}>{props.data.productName}</p>
          <p className={classes.subtitle}>{props.data.bookType}</p>
          <p className={classes.subtitle}>
            {props.data.institution}
          </p>
          {userInfo.data.username && (
            <Button
              onClick={shareLinkHandler}
              className={classes.shareBtn}
            >
              <ShareIcon className={classes.shareIcon} />
              Compartir
            </Button>
          )}
        </div>
        <div className={classes.section}>
          <p className={classes.sectionTitle}>
            Descripción del libro
          </p>
          <p className={classes.sectionInfo}>
            {props.data.description}
          </p>
        </div>
        <div className={classes.section}>
          <p className={classes.sectionTitle}>
            ¿Qué incluye este libro?
          </p>
          <p className={classes.sectionInfo}>
            <ClassOutlinedIcon className={classes.icon} />
            Libro electrónico para la materia{' '}
            {props.data.subjectName}
          </p>
          <p className={classes.sectionInfo}>
            <LockOpenOutlinedIcon className={classes.icon} />
            Academia Mayahii
          </p>
        </div>
      </aside>
      {openMessage && (
        <ShareLink
          openDialog={openMessage}
          closeDialog={closeDialogHandler}
          link={link}
        />
      )}
    </>
  );
};

LeftSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object
};

export default LeftSection;
